import React from "react";
import { Wrench } from "lucide-react";

// Option « frais d'usure » à la publication d'un trajet ≥ 50 km.
export default function PublishWearField({ wear, setWear, caps, divisor }) {
  const capPp = caps?.[wear.cv] ?? 0;
  const askedPp = divisor ? (Number(wear.amount) || 0) / divisor : 0;
  const finalPp = Math.min(askedPp, capPp);
  return (
    <div className="col-span-2 rounded-2xl bg-[#FFF8F1] p-3 street-border-thin" data-testid="publish-wear-field">
      <label className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-2 text-[13px] font-black">
          <Wrench className="h-4 w-4 text-primary" strokeWidth={2.5} />Ajouter des frais d&apos;usure
        </span>
        <input type="checkbox" checked={wear.enabled} onChange={(e) => setWear({ ...wear, enabled: e.target.checked })}
          className="h-5 w-5 accent-[hsl(var(--primary))]" data-testid="publish-wear-toggle" />
      </label>
      {wear.enabled && (
        <div className="mt-2 grid grid-cols-2 gap-2">
          <input inputMode="decimal" value={wear.amount} placeholder="Montant total, ex. 10" style={{ fontSize: "16px" }}
            onChange={(e) => setWear({ ...wear, amount: e.target.value.replace(",", ".") })}
            className="h-11 rounded-xl bg-white px-3 font-[Outfit] font-black street-border-thin focus:outline-none" data-testid="publish-wear-amount" />
          <select value={wear.cv} onChange={(e) => setWear({ ...wear, cv: Number(e.target.value) })} style={{ fontSize: "16px" }}
            className="h-11 rounded-xl bg-white px-3 font-[Outfit] font-black street-border-thin" data-testid="publish-wear-cv">
            {[3, 4, 5, 6, 7].map((v) => <option key={v} value={v}>{v === 7 ? "7 CV et +" : `${v} CV`}</option>)}
          </select>
          <p className="col-span-2 text-[11px] font-semibold leading-snug text-foreground/65" data-testid="publish-wear-cap">
            Plafond légal : {capPp.toFixed(2)}€ par passager.
            {askedPp > 0 && ` Proposé : ${finalPp.toFixed(2)}€ par passager${askedPp > capPp ? " (réduit au plafond)" : ""}.`}
            {" "}Négociable avec le passager, payé à part.
          </p>
        </div>
      )}
    </div>
  );
}
